import { pluginsKeys } from '../components/RICOS/settings-params';
import { verticalEmbedProviders } from '@wix/ricos';

const { event, booking, product } = verticalEmbedProviders;

export const getSelectedPluginsFromSettings = (
  selectedPlugins: Record<string, boolean>,
  defaultPlugins: Record<string, any>,
  selectablePlugins: Record<string, any>,
  additionalSettings: Record<string, any> = {},
) => {
  const { useLinkToSection = false, useVerticalSlimLayout = false } =
    additionalSettings;
  const pluginsConfig: Record<string, any> = {
    LinkPlugin: {
      linkTypes: { anchor: useLinkToSection },
    },
    VerticalEmbed: {
      exposeEmbedButtons: [product, event, booking],
      slimLayout: useVerticalSlimLayout,
    },
  };

  const plugins: any[] = [];
  Object.keys(defaultPlugins).forEach((plugin) => {
    plugins.push(defaultPlugins[plugin](pluginsConfig[plugin]));
  });
  pluginsKeys.forEach((plugin) => {
    if (selectedPlugins[plugin] && selectablePlugins[plugin]) {
      plugins.push(selectablePlugins[plugin](pluginsConfig[plugin]));
    }
  });
  return plugins;
};
